/**
 * @format
 * @Description: Header中导航组件
 * @Autho: 人杰
 * @Date:2019/10/18 11:23
 */

import React, { Component } from 'react';
// 路由对象
import { withRouter } from 'react-router-dom';
// Cookie对象
// 引入antd的组件
import { Button, Select, TreeSelect } from 'antd';

import './HeadreGlobal.less';
import { inject, observer } from 'mobx-react';
import { map } from 'lodash';
import classNames from 'classnames';
import ChildHeader from '../HeaderBar/ChildHeader';

const { TreeNode } = TreeSelect;
const Option = Select.Option;
@withRouter
@inject('HeaderGlobalMod')
@observer
class HeaderGlobalView extends Component {
  // 构造函数
  constructor(props, context) {
    super(props, context);
    this.state = {
      // 组织机构列表
      userOrgList: [],
      // 当前组织机构
      currentOrg: ''
    };
  }

  handleClickNav(item, value) {
    const { style, className, HeaderGlobalMod: store, AppStore: appStore } = this.props;
    store.handleClickNav(item, value);
  }

  //节点递归
  loop = data =>
    data.map(item => {
      if (item.children && item.children.length > 0) {
        return (
          <TreeNode
            style={{ fontSize: '12px' }}
            key={item.id + ''}
            value={item.id + ''}
            title={<span>{item.name}</span>}
          >
            {this.loop(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          style={{ fontSize: '12px' }}
          key={item.id + ''}
          value={item.id + ''}
          title={<span>{item.name}</span>}
        />
      );
    });

  render() {
    //console.log("HeaderGlobalView render")
    const { style = {}, className, HeaderGlobalMod: store, prefix = 'HeaderGlobalNav' } = this.props;
    const wrapCls = classNames(prefix, className);

    return (
      <div className={wrapCls + ' f-row f-ai-center'} style={{ ...style }}>
        {map(store.dataSource, item => {
          const itemCls = classNames({}, `${prefix}__item`);
          const rightCls = classNames({}, `${prefix}__right`);
          if (item.type == 'Select') {
            return (
              <Select
                className={rightCls}
                placeholder='请选择'
                value={store.dataSourceSelect[item.eventKey]}
                onSelect={value => this.handleClickNav(item, value)}
              >
                {item.children &&
                  item.children.map((children, idx) => {
                    return (
                      <Option value={children.eventKey} key={idx}>
                        {children.title}
                      </Option>
                    );
                  })}
              </Select>
            );
          } else if (item.type == 'Message') {
            return (
              <Button onClick={() => this.handleClickNav(item)} className={itemCls} key={item.eventKey}>
                {' '}
                {item.title}
                {item.children[0] && item.children[0].title}
              </Button>
            );
          } else if (item.type == 'String') {
            return <div style={{ marginRight: '10px' }}>{item.title}</div>;
          } else if (item.type == 'Tree') {
            return (
              <TreeSelect
                value={store.dataSourceSelect[item.eventKey]}
                style={{ width: 300 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder='请选择'
                allowClear
                treeDefaultExpandAll
                onChange={e => this.handleClickNav(item, e)}
              >
                {this.loop(item.children)}
              </TreeSelect>
            );
          } else if (item.type == 'custom-service') {
            return React.createElement(ChildHeader['isrvHeaderOption'], {
              onClick: value => this.handleClickNav(item, value),
              value: item.value
            });
          }
        })}
      </div>
    );
  }
}

export default HeaderGlobalView;



// WEBPACK FOOTER //
// ./src/widget/HeaderGlobal/HeaderGlobalView.js